module.exports = __webpack_public_path__ + "static/icons/icon-unlock-app-ee48c7036305a3db7f1494c6f72e228e.svg";